import axios from 'axios';
import { useEffect, useState } from 'react';
import { STOREFRONT_API_KEY, STOREFRONT_API_URL } from '../constants';

export type CancellationWayDataType = {
  text: string;
  image: string;
};

const fetchMetaObjectForCancellationWayQuery = `
query {
  metaobjects(type: "cancellation_way", first: 10, sortKey: "updated_at", reverse:true) {
    nodes {
      fields {
        key,
        value,
        type
      }
      updatedAt
    }
  }
}
`;

/**
 * メタオブジェクトを取得するための関数
 * @returns メタオブジェクトのデータ
 */
const fetchCancellationWayMetaObject = async () => {
  try {
    const response = await axios.post(
      STOREFRONT_API_URL!,
      {
        query: fetchMetaObjectForCancellationWayQuery,
      },
      {
        headers: {
          'X-Shopify-Storefront-Access-Token': STOREFRONT_API_KEY,
        },
      }
    );

    // データを updateAt で降順ソート
    const sortedNodes = response.data.data.metaobjects.nodes.sort((a: any, b: any) => {
      return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
    });

    // 最新のノードを取得
    const latestNode = sortedNodes[0];

    if (!latestNode || !latestNode.fields) {
      throw new Error('No fields found in the response');
    }

    const fields = latestNode.fields;

    const cancellationWayList: CancellationWayDataType[] = [];
    for (let i = 1; i <= fields.length; i++) {
      const text = fields.find((item: any) => item.key === 'text' + i)?.value;
      const image = fields.find((item: any) => item.key === 'image' + i)?.value;

      if (text || image) {
        cancellationWayList.push({ text: text ?? '', image: image ?? '' });
      } else {
        break;
      }
    }

    return { cancellationWayList };
  } catch (err) {
    console.log('error: Meta object data was not found', err);
    return null;
  }
};

/**
 * 特定のクエリを使用してメタオブジェクトを取得するカスタムフック
 * @param query 任意のGraphQLクエリ
 * @returns メタオブジェクトのデータ
 */
export const useCancellationWayData = () => {
  const [cancellationWayList, setCancellationWayList] = useState<CancellationWayDataType[]>([]);
  useEffect(() => {
    (async () => {
      const response = await fetchCancellationWayMetaObject();
      if (response) {
        setCancellationWayList(response.cancellationWayList);
      }
    })();
  }, []);

  return {
    cancellationWayList,
  };
};
